import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import columns from "./columns";
import useBiodiversityList from "../hooks/useBiodiversityList";
import { useErrorBoundary } from "react-error-boundary";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";

const style = {
  listContainer: { paddingTop: "8px", height: "77vh", width: "100%" },
  list: { "&:hover": { cursor: "pointer" } },
  actionButton: { opacity: 1 },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    marginTop: "9px",
  },
} as const;

function BiodiversityList() {
  const [displaySold, setDisplaySold] = React.useState<string>("all units");
  const { showBoundary } = useErrorBoundary();

  const handleDisplaySold = (
    _: React.MouseEvent<HTMLElement>,
    newSoldDisplay: string,
  ) => {
    if (displaySold !== newSoldDisplay) {
      setDisplaySold(newSoldDisplay);
    }
  };
  const getSoldUrl = (displaySold: string) => {
    const params = new URLSearchParams(
      displaySold === "sold units"
        ? { isSold: "true" }
        : displaySold === "unsold units"
          ? { isSold: "false", edgeOrFullBoxArea: "Full" }
          : {},
    );

    return params.toString() ? `?${params}` : "";
  };

  const urlSoldQuery = getSoldUrl(displaySold);

  const { loading, biodiversityList, error } =
    useBiodiversityList(urlSoldQuery);

  React.useEffect(() => {
    if (error) {
      showBoundary(error);
    }
  }, [error, showBoundary]);

  return (
    <>
      <Box data-testid="biodiversity-list-container" sx={style.pageContainer}>
        <Box
          style={{
            display: "flex",

            left: 25,
            marginBottom: "10px",
          }}
        >
          <ToggleButtonGroup
            value={displaySold}
            exclusive
            onChange={handleDisplaySold}
            aria-label="sold-display"
          >
            <ToggleButton
              value="all units"
              aria-label="all-units"
              style={{ height: "38px" }}
            >
              <Tooltip title="All Units">
                <AssignmentIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton
              value="sold units"
              aria-label="sold-units"
              style={{ height: "38px" }}
            >
              <Tooltip title="Sold Units">
                <AssignmentIndIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton
              value="unsold units"
              aria-label="unsold-units"
              style={{ height: "38px" }}
            >
              <Tooltip title="Unsold Units [full]">
                <AssignmentLateIcon />
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Box
          data-testid="biodiversity-list-table-container"
          sx={style.listContainer}
        >
          <DataGrid
            data-testid="biodiversity-list-table"
            sx={style.list}
            rows={biodiversityList}
            columns={columns(displaySold)}
            autoPageSize
            loading={loading}
            disableRowSelectionOnClick
            slots={{
              toolbar: GridToolbar,
            }}
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
            }}
          />
        </Box>
      </Box>
    </>
  );
}

export default BiodiversityList;
